<template>
  <div class="d-inline-block m-l-20px">
    <span>Imagens enviadas na cotação:</span>
    <div class="mt-2">
      <a
        v-for="(imagem, index) in allImages"
        class="download-images"
        :href="`https://api.construp.com.br/storage/upload/` + imagem"
        download
        target="_blank"
        :key="index"
      >
        <img
          :src="`https://api.construp.com.br/storage/upload/` + imagem"
          :alt="'Imagem ' + [index + 1] + ' enviada na cotação'"
          width="50px"
          height="50px"
        />
        <i class="fas fa-download fs-20 download-icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allImages: {
      type: Array,
      required: true,
    },
  },
};
</script>
